<button class="primary-btn" (click)="createActivity()">
  <mat-icon>add</mat-icon>
  Create Activity
</button>